import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {Businesses} from 'api';
import {ShowIf} from 'components/utils';
import {LoadingPage} from 'components/loading-page';
import {DateTime} from 'components/UI/DateTime';
import truncate from 'lodash/truncate';
import {Link} from 'react-router-dom';
import {NoContent} from 'components/no-content';
import {connect} from 'react-redux';

class MyBusinessAnnouncementContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isLoading: false,
      data: [],
      count: 0,
      skip: 0,
      limit: 10
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.business) {
      Businesses.actions.countAnnouncement.request({id: this.props.business.id}).then((response) => {
        this.setState({count: response.data.count});
        this.getList();
      });
    }
  }

  getList() {
    this.setState({isLoading: true});
    const params = {
      id: this.props.business.id,
      filter: {
        limit: this.state.limit,
        skip: this.state.skip
      }
    };
    Businesses.actions.announcements.request(params).then(response => {
      if (response && response.data) {
        let announcements = this.state.data;
        response.data.map((item, idx) => {
          announcements.push(item);
        });
        this.setState({data: announcements, isLoading: false});
      }
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getList();
    });
  }

  render() {
    const {skip, limit, count, isLoading} = this.state;
    return (
      <section className="the-news announcement">
        <ShowIf condition={this.state.data.length > 0}>
          <Tabs className='news-tab'>
            <TabList className='news-tab-list'>
              <div className='news-tab-wrap'>
                <Tab className='news-tab-item'>
                  <div className='news-tab-wrap-item'>Tất cả ({count})</div>
                </Tab>
              </div>
            </TabList>
            <div className='news-tab-content'>
              <TabPanel className='news-tab-panel'>
                <section className="notify-item">
                  {
                    this.state.data.map((item, idx) => {
                      return (
                        <div className="item-notify">
                          <div className='item-notify-left-time'>
                            <p className='item-notify-time'><DateTime dateTime={item.updatedAt} format="HH:mm" /></p>
                            <p className='item-notify-day'><DateTime dateTime={item.updatedAt} format="MM/DD/YYYY" /></p>
                          </div>
                          <p className='item-notify-right-desc'>
                            {truncate(item.content, {length: 250, separator: ' '})}
                            <Link to={`/my-business/announcements/${item.id}`} className="need-offer-item-link">&nbsp;xem chi tiết</Link>
                          </p>
                        </div>
                      );
                    })
                  }
                  <ShowIf condition={!isLoading && this.state.data.length > 0 && (skip + limit) < count}>
                    <div className='btn-see-more-wrap'>
                      <button className='btn-see-more' onClick={this.loadMore}>Xem thêm</button>
                    </div>
                  </ShowIf>
                </section>
              </TabPanel>
            </div>
          </Tabs>
        </ShowIf>
        <ShowIf condition={this.state.data.length == 0 && !isLoading}>
          <NoContent content='Không có thông báo nào'/>
        </ShowIf>
      </section>
    );
  }
}

const mapStateToProp = (state) => {
  let business = {};
  if (state.myBusinesses && state.myBusinesses.mainBusiness) {
    business = state.myBusinesses.mainBusiness;
  }

  return {
    auth: state.auth,
    business
  };
};

export default connect(mapStateToProp)(MyBusinessAnnouncementContent);



// WEBPACK FOOTER //
// ./components/my-business/sub-view/announcement/MyBusinessAnnouncementContent.jsx